// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    html, body {
      margin: 0; /* Remove margens externas */
      padding: 0; /* Remove padding */
      height: 27.94cm; /* Altura personalizada */
      width: 21.59cm; /* Largura personalizada */
      box-sizing: border-box; /* Inclui padding e border no tamanho total */ /* Força o uso de cores de fundo */
      print-color-adjust: exact; 
    }

    /* Opcional: Centralizar o conteúdo na página */
    .print-area {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

.papelEiquetaBody{
    width: 21.59cm;
}

.pdfProdutoImpressao{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 21.59cm;
}

.pdfProdutoImpressao .pageProd{
    display: flex;
    justify-content: space-between;
    width: 98%;
    height: 27.94cm;
    margin: 0 auto;
    height: 100%;
    margin-bottom: 1%;
    page-break-after: always;
}



.pdfProdutoImpressao .colunaProd{
    width: 29%;
    margin: 2% 2% 0 2%;
    height: 27.94cm;    
}

.pdfProdutoImpressao .colunaProd .etiqueta{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 10%;
    background-color: #fff;
    /* border: 1px solid #888; */
}

.pdfProdutoImpressao .etiqueta .barcode{
    width: 83.7%;
    height: fit-content;
    min-height: fit-content;
    max-height: 50%;
    margin-top: 12.03px;
}

.pdfProdutoImpressao .etiqueta .descPrinc{
    width: 85%;
    display: flex;
    justify-content: space-between;
    font-family: 'Roboto', 'sans-serif';
    font-weight: 500;
    font-size: 10px;
}

.pdfProdutoImpressao .etiqueta .descPrinc:nth-child(2){
    margin-top: 6px;
}


.pdfProdutoImpressaoAvulso {
    display: grid;
    grid-template-columns: 40% 60%;
    justify-content: center;
    margin-top: 40px;
  }

  .pdfProdutoImpressaoAvulso .insereProdutos{
    display: flex;
    flex-direction: column;
    align-items: center;
  }


.pdfProdutoImpressaoAvulso .insereProdutos > label {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #333;
    width: 20%;
  }
  



.pdfProdutoImpressaoAvulso .insereProdutos label {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #333;
  }
  
  .pdfProdutoImpressaoAvulso .insereProdutos input[type="text"],
  .pdfProdutoImpressaoAvulso .insereProdutos input[type="date"] {
    padding: 8px 10px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 4px;
    transition: border 0.3s ease;
    min-width: 150px;
  }
  
  .pdfProdutoImpressaoAvulso .insereProdutos input[type="text"]:focus,
  .pdfProdutoImpressaoAvulso .insereProdutos input[type="date"]:focus {
    border-color: #007bff;
    outline: none;
  }
  
  .pdfProdutoImpressaoAvulso .insereProdutos button {
    padding: 10px;
    background-color: #007bff;
    color: white;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 10px;
  }
  
  .pdfProdutoImpressaoAvulso .insereProdutos button:hover {
    background-color: #0056b3;
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/pdfProdutoImpressao.css"],"names":[],"mappings":"AAAA;IACI;MACE,SAAS,EAAE,4BAA4B;MACvC,UAAU,EAAE,mBAAmB;MAC/B,eAAe,EAAE,yBAAyB;MAC1C,cAAc,EAAE,0BAA0B;MAC1C,sBAAsB,EAAE,6CAA6C,EAClC,kCAAkC;MACnE,yBAAyB;IAC7B;;IAEA,+CAA+C;IAC/C;MACE,YAAY;MACZ,WAAW;MACX,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;EACF;;AAEF;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,eAAe;IACf,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;AAC5B;;;;AAIA;IACI,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;;AAGF;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;;;;AAKF;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;;IAEE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["@media print {\r\n    html, body {\r\n      margin: 0; /* Remove margens externas */\r\n      padding: 0; /* Remove padding */\r\n      height: 27.94cm; /* Altura personalizada */\r\n      width: 21.59cm; /* Largura personalizada */\r\n      box-sizing: border-box; /* Inclui padding e border no tamanho total */\r\n      -webkit-print-color-adjust: exact; /* Força o uso de cores de fundo */\r\n        print-color-adjust: exact; \r\n    }\r\n\r\n    /* Opcional: Centralizar o conteúdo na página */\r\n    .print-area {\r\n      height: 100%;\r\n      width: 100%;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n    }\r\n  }\r\n\r\n.papelEiquetaBody{\r\n    width: 21.59cm;\r\n}\r\n\r\n.pdfProdutoImpressao{\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    width: 21.59cm;\r\n}\r\n\r\n.pdfProdutoImpressao .pageProd{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 98%;\r\n    height: 27.94cm;\r\n    margin: 0 auto;\r\n    height: 100%;\r\n    margin-bottom: 1%;\r\n    page-break-after: always;\r\n}\r\n\r\n\r\n\r\n.pdfProdutoImpressao .colunaProd{\r\n    width: 29%;\r\n    margin: 2% 2% 0 2%;\r\n    height: 27.94cm;    \r\n}\r\n\r\n.pdfProdutoImpressao .colunaProd .etiqueta{\r\n    display: flex;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    height: 10%;\r\n    background-color: #fff;\r\n    /* border: 1px solid #888; */\r\n}\r\n\r\n.pdfProdutoImpressao .etiqueta .barcode{\r\n    width: 83.7%;\r\n    height: fit-content;\r\n    min-height: fit-content;\r\n    max-height: 50%;\r\n    margin-top: 12.03px;\r\n}\r\n\r\n.pdfProdutoImpressao .etiqueta .descPrinc{\r\n    width: 85%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-family: 'Roboto', 'sans-serif';\r\n    font-weight: 500;\r\n    font-size: 10px;\r\n}\r\n\r\n.pdfProdutoImpressao .etiqueta .descPrinc:nth-child(2){\r\n    margin-top: 6px;\r\n}\r\n\r\n\r\n.pdfProdutoImpressaoAvulso {\r\n    display: grid;\r\n    grid-template-columns: 40% 60%;\r\n    justify-content: center;\r\n    margin-top: 40px;\r\n  }\r\n\r\n  .pdfProdutoImpressaoAvulso .insereProdutos{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n\r\n.pdfProdutoImpressaoAvulso .insereProdutos > label {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 14px;\r\n    color: #333;\r\n    width: 20%;\r\n  }\r\n  \r\n\r\n\r\n\r\n.pdfProdutoImpressaoAvulso .insereProdutos label {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 14px;\r\n    color: #333;\r\n  }\r\n  \r\n  .pdfProdutoImpressaoAvulso .insereProdutos input[type=\"text\"],\r\n  .pdfProdutoImpressaoAvulso .insereProdutos input[type=\"date\"] {\r\n    padding: 8px 10px;\r\n    font-size: 14px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin-top: 4px;\r\n    transition: border 0.3s ease;\r\n    min-width: 150px;\r\n  }\r\n  \r\n  .pdfProdutoImpressaoAvulso .insereProdutos input[type=\"text\"]:focus,\r\n  .pdfProdutoImpressaoAvulso .insereProdutos input[type=\"date\"]:focus {\r\n    border-color: #007bff;\r\n    outline: none;\r\n  }\r\n  \r\n  .pdfProdutoImpressaoAvulso .insereProdutos button {\r\n    padding: 10px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    font-weight: bold;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .pdfProdutoImpressaoAvulso .insereProdutos button:hover {\r\n    background-color: #0056b3;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
